import { render, staticRenderFns } from "./mock-order-confirmation-form.vue?vue&type=template&id=9fd9ab4c&scoped=true&"
import script from "./mock-order-confirmation-form.vue?vue&type=script&lang=js&"
export * from "./mock-order-confirmation-form.vue?vue&type=script&lang=js&"
import style0 from "./mock-order-confirmation-form.vue?vue&type=style&index=0&id=9fd9ab4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd9ab4c",
  null
  
)

export default component.exports